<template>
  <span
    class="p-button p-button-text"
    role="button"
    data-cy="calculator-toggle"
    @click="handleClick"
  >
    <slot>
      <icon :icon="['fas', 'calculator']" />
    </slot>
  </span>
</template>

<script setup lang="ts">
/*
CalculatorToggle uses an injected method from ScenarioDetail to handle relaying
which sections of the side calculator should be open from within the main
page
*/
import type { PropType } from "vue";
import { nextTick } from "vue";
import useCalculatorDomStore from "@/composables/scenarioCalculations/useCalculatorDomStore";
import { useSettingsStore } from "@/store";
import type { EquipmentCalculatorSectionKey } from "@/composables/scenarioCalculations/calculationTypes";

const {
  activeCalculatorSections,
  pushToActiveCalculatorSections,
  currentScenarioSideCalcsOpen
} = useSettingsStore();

const props = defineProps({
  sectionIds: {
    type: Array as PropType<Array<EquipmentCalculatorSectionKey>>,
    default: () => []
  }
});

const { getCalculatorSection } = useCalculatorDomStore();

const handleClick = () => {
  // Open side calc if not already open inside of state
  if (!currentScenarioSideCalcsOpen.value) {
    currentScenarioSideCalcsOpen.value = true;
  }
  props.sectionIds.forEach(id => {
    if (!activeCalculatorSections.value.includes(id)) {
      pushToActiveCalculatorSections(id);
    }
  });

  nextTick(() => {
    const [firstEl] = props.sectionIds.map(id => getCalculatorSection(id));
    if (firstEl) {
      // if any of footer is visible, push up to top of footer
      // sidebar does not go into footer so throws off coords
      const visibleBottomY = window.scrollY + window.innerHeight;
      const fullHeight = document.body.clientHeight;
      const FOOTER_HEIGHT = 80;
      if (fullHeight - visibleBottomY < FOOTER_HEIGHT) {
        window.scrollTo({
          top: fullHeight - FOOTER_HEIGHT - window.innerHeight,
          behavior: "auto"
        });
      }

      // scroll relative to the top of splitter-right container
      const splitterRight = document.getElementById("splitter-right");
      if ("offsetTop" in firstEl) {
        const topPos = firstEl.offsetTop;
        if (splitterRight) {
          splitterRight.scrollTo({ top: topPos - 20, behavior: "smooth" });
        }

        firstEl.classList.add("flash");

        setTimeout(() => {
          firstEl.classList.remove("flash");
        }, 500);
      }
    }
  });
};
</script>
